import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { Register2Component } from './register2/register2.component';
import { Register3Component } from './register3/register3.component';
import { Register1Component } from './register1/register1.component';
import { RegisterGuardService } from './register-guard.service';

const routes: Routes = [
	{ path: '', component: Register1Component },
	{ path: 'step2', component: Register2Component, data: { step: 2} },
	{ path: 'step3', component: Register3Component,
	// canActivate: [RegisterGuardService],
		data: { step: 3}
	},
	{ path: 'profile',
	loadChildren: () => import('../profiles/profiles.module').then(m => m.ProfilesModule),
	// canActivate: [RegisterGuardService],
	data: { step: 4}
	},
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
  providers: [
	RegisterGuardService,
  ]
})
export class RegisterRoutingModule { }
